import fetch from '../../plugins/axios'
export default {
	namespaced: true,
	state: {
		list: [],
		sitePager: {},
		loading: false,
		mapList: [],
		mapcenter: [104.07, 30.67]
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		},
		// 停用启用数据改变后，改变本地数据
		changeList(state: any, index: number) {
			if(state['list'][index].status == '0'){
				state['list'][index].status = '1';
			}else{
				state['list'][index].status = '0';
			}
		}
	},
	actions: {
		// 添加网点
		async addSite({ commit }: any, params: any) {
			return await fetch({
				url: '/admin/sites',
				method: 'post',
				data: params
			})
		},
		// 获取网点列表
		async getSiteList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/sites',
				params
			})
			commit('setState',{key: 'list',data: res.docs})
			commit('setState',{key:'sitePager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
		},
		// 获取网点信息
		async getSiteDetail({ commit }: any, id: string) {
			return await fetch({
				url: `/admin/sites/${id}`,
			})
		},
		// 编辑网点
		async editSite({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/sites/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 网点停用
		async modifyStatus({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/sites/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 快递对接(创建)
		async createDocking({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/siteConnection`,
				method: 'post',
				data: params
			})
		},
		// 导入网点
		async importData({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/sitesImport`,
				method: 'get',
				data: params
			})
		},
		// 获取地图网点列表
		async getMapSiteList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/site/location',
				params
			})
			commit('setState',{key: 'mapList',data: res})
			commit('setState',{key: 'mapcenter',data: res[0].location})
			commit('setState',{key:'loading',data: false})
		},
		
	}
}